export default __webpack_public_path__ + "static/media/femaleIcon.f78a9c76.svg";